import React, { useState } from "react";
import { Card, Col, Row, Table, Typography, Button, Image, Modal } from "antd";
import { PAGINATION } from "../../_redux/constant";
import dayjs from "dayjs";
import { get, map } from "lodash";
import { DEFAULT_VALUE } from "../../../app/_redux/constants";
import { PlayCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;
function Logs({
  total_elements,
  loading,
  dataSource,
  params,
  onChangeParam,
  onClickRenew,
  openTypes
}) {
  const [orderVideoModal, setOrderVideoModal] = useState({
    visible: false,
    link: ""
  });

  const CARD_STYLE = {
    borderRadius: "0.42rem",
    boxShadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)"
  };
  const CARD_BODY_STYLE = {
    padding: "0px 10px 10px 10px"
  };
  const CARD_HEAD_STYLE = {
    padding: "0px 9px 0px 9px",
    borderBottom: "none"
  };
  const SNoStyle = {
    color: "#14a05b",
    fontWeight: "bold",
    display: "inline-block",
    textAlign: "center"
  };

  const columns = [
    {
      dataIndex: "stt",
      title: "STT",
      width: 50,
      align: "center"
    },
    {
      dataIndex: "station_name",
      title: "Kho",
      key: "station_name",
      render: (station_name, record) => {
        return (
          <Text>
            <span style={SNoStyle}>{get(record, "station_id", "-")}</span>
            {station_name ? " | " + station_name : " | " + DEFAULT_VALUE}
          </Text>
        );
      }
    },
    {
      dataIndex: "gate_name",
      key: "gate_name",
      title: "Tên cổng",
      width: 250,
      render: gate_name => gate_name || DEFAULT_VALUE
    },
    {
      dataIndex: "open_type",
      key: "open_type",
      title: "Kiểu mở",
      width: 125,
      render: open_type => (open_type ? openTypes[open_type] : DEFAULT_VALUE)
    },
    {
      dataIndex: "username",
      key: "username",
      title: "Username",
      width: 150,
    },
    {
      dataIndex: "license_plate",
      key: "license_plate",
      title: "Biển số",
      width: 125,
      render: license_plate => license_plate || DEFAULT_VALUE
    },
    {
      dataIndex: "license_plate_images",
      key: "license_plate_images",
      title: "Ảnh biển số",
      align: "center",
      width: 125,
      render: value => {
        return (
          <div className="d-flex align-items-center justify-content-center">
            <Image.PreviewGroup>
              {map(value, img => (
                <Image
                  key={img}
                  width={75}
                  height={75}
                  src={img}
                  preview={{
                    src: img
                  }}
                />
              ))}
            </Image.PreviewGroup>
          </div>
        );
      }
    },
    {
      dataIndex: "extra_overview_images",
      key: "extra_overview_images",
      title: "Ảnh toàn cảnh",
      align: "center",
      width: 125,
      render: value => {
        return (
          <div className="d-flex align-items-center justify-content-center">
            <Image.PreviewGroup>
              {map(value, img => (
                <Image
                  key={img?.origin}
                  width={75}
                  height={75}
                  src={img?.thumbnail}
                  preview={{
                    src: img?.origin
                  }}
                />
              ))}
            </Image.PreviewGroup>
          </div>
        );
      }
    },
    {
      dataIndex: "extra_overview_videos",
      key: "extra_overview_videos",
      title: "Video toàn cảnh",
      align: "center",
      width: 100,
      render: videos => {
        let onPreviewVideo = link => {
          setOrderVideoModal({ visible: true, link });
        };
        return (
          <div
            className="d-flex align-items-center justify-content-center"
            style={
              !videos || videos.length <= 0 ? { width: 450, height: 75 } : {}
            }
          >
            {map(videos, video => (
              <div
                key={video?.origin}
                style={{ position: "relative", cursor: "pointer" }}
                onClick={() => onPreviewVideo(video?.origin)}
                className="mr-1"
                title="Xem video"
              >
                <img src={video?.thumbnail} height={75} width={75} />
                <div className="videoPreview" />
                <span className="videoPreviewIcon">
                  <PlayCircleOutlined />
                </span>
              </div>
            ))}
          </div>
        );
      }
    },
    {
      dataIndex: "log_time",
      key: "log_time",
      title: "Thời gian",
      align: "center",
      width: 200,
      render: value =>
        value ? dayjs(value).format("DD/MM/YYYY HH:mm:ss") : DEFAULT_VALUE
    }
  ];

  const renderCardExtra = () => {
    return (
      <div className="d-flex aligns-items-center">
        <Button onClick={onClickRenew}>Làm mới</Button>
      </div>
    );
  };
  return (
    <Card
      className="log__container"
      size="small"
      style={CARD_STYLE}
      bodyStyle={CARD_BODY_STYLE}
      headStyle={CARD_HEAD_STYLE}
      title={
        <Row align="middle" gutter={[8]} justify="start">
          <Col>
            <Text>
              Tổng số log: <Text className="text-dark">{total_elements}</Text>
            </Text>
          </Col>
        </Row>
      }
      extra={renderCardExtra()}
    >
      <Table
        loading={{
          spinning: loading,
          delay: 500
        }}
        rowKey="id"
        bordered
        columns={columns}
        dataSource={dataSource}
        pagination={{
          pageSize: params.size,
          current: params.page,
          defaultPageSize: PAGINATION.log.page,
          total: total_elements,
          showSizeChanger: true,
          onChange: (page, pageSize) => {
            onChangeParam({
              page: page,
              size: pageSize
            });
          }
        }}
      />
      <Modal
        title="Xem video hành chính"
        width={800}
        open={orderVideoModal.visible}
        bodyStyle={{ padding: 0 }}
        footer={null}
        onCancel={() => {
          setOrderVideoModal({ visible: false, link: "" });
        }}
      >
        <video src={orderVideoModal.link} controls autoPlay width={800} />
      </Modal>
    </Card>
  );
}

export default React.memo(Logs);
